import './BetaTag.css'

/* eslint-disable formatjs/no-literal-string-in-jsx */

export function BetaTag() {
  return <span className="beta-tag">BETA</span>
}
